import { ViteReactSSG } from 'vite-react-ssg'
import routes from './App'
import { initAnalytics } from './utils/analytics'

if (typeof window !== 'undefined') {
  initAnalytics()
}

export const createRoot = ViteReactSSG(
  { 
    routes,
    basename: import.meta.env.BASE_URL
  }
)